<template>
  <aside class="document-page cover-page">
    <section>
      <div class="pt-32">
        <template v-if="logo">
          <img
            alt="Plan Logo"
            :src="logo"
            class="block w-auto max-w-64 mx-auto mb-8"
          >
        </template>

        <DocumentPageTitle
          :title="plan.name"
          class="!text-center"
        />
      </div>

      <div class="bg-secondary-alt-subtle px-12 py-10">
        <div
          class="w-full mx-auto text-sm text-gray-800 leading-6 text-center"
          v-html="plan.description"
        />
      </div>

      <div class="p-12">
        <div class="text-center">
          <p class="text-base mb-1.5">
            <span class="text-gray-800 font-medium">District:</span>&nbsp;
            <span>{{ plan.district.name }}</span>
          </p>

          <p class="text-xs">
            <span class="text-gray-800 font-medium">Last Published:</span>&nbsp;
            <span>{{ dateFormatter.formatShortDateAndTime(plan.lastPublishedAt) }}</span>
          </p>
        </div>
      </div>
    </section>
  </aside>
</template>

<script setup>

import { useDateFormatter } from '@/composables/index.js';
import DocumentPageTitle from '../DocumentPageTitle.vue';

const props = defineProps({
  plan: {
    type: Object,
    default: () => ({}),
  },
});

const dateFormatter = useDateFormatter();

let logo;

if (props.plan.logo instanceof File) {
  logo = URL.createObjectURL(props.plan.logo);
} else {
  logo = props.plan.logo;
}
</script>
